import { Select,Form } from 'antd'
import React, { useEffect, useState } from 'react'
import { useQiyeListQuery } from '../../store/dianshangtaizhangApi';

function FirmSelect(props) {
    const [list,setList] = useState();
    const {data,isSuccess} =useQiyeListQuery()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {qy_id,qy_name,qy_gly_name,qy_gly_phone }=item;
                    return item = {value:qy_id,label:qy_name,qy_gly_name,qy_gly_phone }
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
                style={props.formStyle}
            >
                <Select 
                    options={list} 
                    onChange={(_,f) => {
                        props.onChange(f.value,f.label,f.qy_gly_name,f.qy_gly_phone)
                    }}
                    defaultValue={props.defaultId}
                    placeholder={props.placeholder}
                    style={props.style}
                />
            </Form.Item>
        </>
    )
}

export default FirmSelect